// "Recent articles" cards on the home page (newest posts).

import type { BlogPost } from '@content/types';
import { Img } from '@components/cms/Img';
import { NavLink } from '@components/webflow';
import { cx } from '@components/webflow/element';
import { shortDate } from '@lib/format';

export function HomeRecentPosts({ posts }: { posts: BlogPost[] }) {
  return (
    <div fs-list-filteringclass="is-list-filtering" className="blog-header_list-wrapper w-dyn-list">
      <div role="list" className="blog-header_list w-dyn-items">
        {posts.map((post, i) => (
          <div role="listitem" className="blog-header_item w-dyn-item" key={i}>
            <NavLink
              fs-list-element="item-link"
              className="blog-header_item-link w-inline-block"
              href={`/blog/${post.slug}`}
            />
            <div className="blog-header_image-wrapper">
              <Img image={post.cardImage} loading="lazy" className="blog-header_image" />
            </div>
            <div fs-list-nest="tags" fs-list-element="nest-target" className="blog-header_text-wrapper">
              <div className="margin-bottom margin-xsmall is-blog">
                <div className={cx('tagline-container text-size-small', !post.category && 'w-dyn-bind-empty')}>
                  {post.category}
                </div>
                <div className="blog-header_date-wrapper">
                  <div className="text-size-small">{shortDate(post.date)}</div>
                </div>
              </div>
              <div className="margin-bottom margin-tiny">
                <h3 className="heading-style-h5">{post.title}</h3>
              </div>
              <div className="text-body-active text-size-regular is-post">{post.summary}</div>
              <div fs-list-instance="tags" fs-list-element="wrapper" className="blog-author_wrapper w-dyn-list">
                <div role="list" className="blog-author_list w-dyn-items">
                  {post.authors.map((author, i) => (
                    <div role="listitem" className="blog_author-item w-dyn-item" key={i}>
                      <div className="blog-header_author-wrapper">
                        <div className="blog-header_author-image-wrapper">
                          <Img image={author.image} loading="lazy" className="blog-header_author-image" />
                        </div>
                        <div className="blog-header_author-text">
                          <div className="text-size-small-4 text-weight-semibold">{author.name}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
